export function formatDate(dateStr) {
  if (!dateStr) return "";

  const dateObj = new Date(dateStr);

  return dateObj.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}
